/**
 * AI attribution (contract 0.10.62, db/README Revision 103): the web app tells the server when it is running in an
 * automated browser, so a person's actions taken by an AI driving the browser are recorded as "AI".
 *
 * Two cheap signals only, no fingerprinting:
 * - `navigator.webdriver === true` — set by WebDriver, Playwright, Puppeteer and Chrome DevTools-driven automation;
 * - a headless user agent (`HeadlessChrome`, or the word `Headless`).
 *
 * This is the browser's own report. An honest automation tool sends it; a tool that hides `navigator.webdriver` and its
 * user agent is not detected. MCP calls are marked by the server whatever the client says (the authoritative path).
 */
export const CLIENT_AGENT_HEADER = "X-Giraffe-Client-Agent";
export const AUTOMATION_VALUE = "automation";

export interface AutomationSignals {
  webdriver?: boolean;
  userAgent?: string;
}

/** Pure, for tests: true when either signal says automation. */
export function looksAutomated(signals: AutomationSignals): boolean {
  if (signals.webdriver === true) return true;
  return /\bHeadless/i.test(signals.userAgent ?? "");
}

/** The current browser's signals; false outside a browser. */
export function isAutomatedBrowser(): boolean {
  if (typeof navigator === "undefined") return false;
  return looksAutomated({ webdriver: (navigator as Navigator & { webdriver?: boolean }).webdriver, userAgent: navigator.userAgent });
}
